import z from "zod/v4";
import {
  deliveryPerformanceByCarrier,
  deliveryPerformanceByDestination,
  deliveryPerformanceFilterInput,
} from "./delivery-analytics-v2-types";

const deliveryAnalyticsV2TablesData = z.object({
  byCarrier: z.array(deliveryPerformanceByCarrier),
  byState: z.array(deliveryPerformanceByDestination),
  byCountry: z.array(deliveryPerformanceByDestination),
});

export type DeliveryAnalyticsV2TablesData = z.infer<
  typeof deliveryAnalyticsV2TablesData
>;

export const getDeliveryAnalyticsV2Tables = {
  name: "getDeliveryAnalyticsV2Tables",
  input: deliveryPerformanceFilterInput,
  output: deliveryAnalyticsV2TablesData,
};
